module.exports = __webpack_public_path__ + "static/media/folder.f8d1b500.svg";